export default defineNuxtPlugin(() => {
  const appConfig = useAppConfig()

  if (import.meta.client) {
    const root = document.documentElement
    // Sync app.config values to CSS variables
    if (appConfig.theme?.colors?.primary) {
      root.style.setProperty('--app-primary', appConfig.theme.colors.primary)
    }
  }
})
